import React from 'react';
import {Modal} from 'react-bootstrap';
import plusIcon from '../../../images/plus.png';
import './index.scss';
import Button from '../../Button';

interface IConfirmationModalProps {
  show: boolean;
  handleClose: ()=>void;
  onConfirm: () => void;
  message: string;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}
const ConfirmationModal = (props: IConfirmationModalProps) => {
  const {
    show,
    handleClose,
    message,
    onConfirm,
    title = 'Confirm Action',
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
  } = props;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size='xl'
      className='confirm-modal-wrapper'
    >
      <Modal.Body>
        <div className="confirm-modal">
          <div onClick={handleClose} className="close-icon">
            <img src={plusIcon} alt="" className="" />
          </div>
          <div className="confirm-title">{title}</div>
          <div className="confirm-message">{message}</div>
          <div className='confirm-actions'>
             <Button onClick={handleClose} className='cancel-btn'>{cancelLabel}</Button>
             <Button onClick={onConfirm} className='confirm-btn'>{confirmLabel}</Button>
           </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmationModal;
